import Vue from "vue";

// tslint:disable:no-submodule-imports
import { SnotifyService } from "vue-snotify/SnotifyService";

declare module "vue/types/vue" {
  interface Vue {
    readonly $snotify: SnotifyService;
  }
}
export default Vue;
